<template>
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>
</template>
<script lang="ts" setup>
import useProvideApi from './api/useProvideApi';
import useClientApi from './api/client-only/useClientApi.client';

const baseApiUrl = useBaseApiUrl();
useProvideApi(baseApiUrl);
useClientApi(baseApiUrl);
useNloProvideApi('krasloten');
</script>

<style>
/* TODO: This is the ticket to fix the underline issue with CommonButtonLink https://nederlandseloterij.atlassian.net/browse/KD-2493 */
/* Quick fix for CommonButtonLink underline issue */
/* CSS modules hashed classes override - highest specificity */
a[class] {
	text-decoration: none !important;
}

/* Restore underlines for regular content links */
article a:not([class]),
.content a:not([class]),
p a:not([class]) {
	text-decoration: underline !important;
}
</style>
